import { ref, readonly, onMounted } from 'vue'
import { useRoute } from 'vue-router'

// Client-only dev toggle. Enable with ?dev=true (persisted in sessionStorage for the tab).
// SSR always renders devMode=false — sessionStorage is client-only and onMounted never runs
// on the server, so there is no hydration mismatch: both sides start hidden, then the client
// flips it after mount. Shared module ref is safe here: it is never mutated during SSR.
const DEV_MODE_KEY = 'dev_mode'
const _devMode = ref(false)

export function useDevMode() {
  const route = useRoute()

  onMounted(() => {
    if (route.query.dev === 'true') sessionStorage.setItem(DEV_MODE_KEY, '1')
    _devMode.value = sessionStorage.getItem(DEV_MODE_KEY) === '1'
  })

  return { devMode: readonly(_devMode) }
}
